import $ from 'jquery';
import Handlebars from 'handlebars';
import Slicker from 'components/slicker';
import txtVehicles from './vehicle.strip.hbs';
import seriesManagerXform from 'lib/transforms/seriesManager.dcr';
import imgix from 'lib/imgix';
import tdaConfig from 'lib/util/tda.config';
import scroller from 'lib/scroller';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import anAddContext from 'lib/analytics/context.add';
import blocks from 'lib/analytics/blocks/index';
import 'lib/helpers/toJSON';

const __tmplVehicleStrip = Handlebars.compile(txtVehicles);

// supplement the vehicles arr with an image and a link
function __supplementVehicles(vehicles) {
  return vehicles.map(vehicle => ({
    image: imgix(
      `/assets/img/vehicles/${vehicle.series}/${vehicle.seriesYear}/default-offer-card.png`,
      { w: 240 }
    ),
    link: `/${tdaConfig.site.context_url}/vehicles/${vehicle.series}/`,
    dataLayer: blocks.seriesBlock({
      series_code: vehicle.series,
      year: vehicle.seriesYear
    }),
    ...vehicle,
  }));
}

const vehicleStrip = {
  init(el, config) {
    this.$el = $(el);
    this.config = config;
    this.getVehicles();
    this.compAnalytics();
  },

  getVehicles() {
    seriesManagerXform(this.config.seriesManager)
      .then((vehicles) => {
        let vehicleCtx = __supplementVehicles(vehicles);
        this.drawTmpl(vehicleCtx);
        this.doSlides();
      });
  },

  drawTmpl(vehicles) {
    var ctx = {
      title: this.config.title,
      vehicles: vehicles
    };
    console.log('CTX for vehicle-strip: ', ctx); // eslint-disable-line no-console
    this.$el.html(__tmplVehicleStrip(ctx));
  },

  doSlides() {
    return new Slicker({
      $slider: $('.carousel', this.$el),
      slickOptions: {
        slide: '.slide',
        // mobilefirst: true, // this is causing issues, need to do in reverse
        arrows: true,
        dots: true,
        paddingBottom: 60,
        slidesToShow: 4,
        slidesToScroll: 4,
        phone: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    });
  },

  compAnalytics() {
    anAddContext(
      this.$el,
      blocks.sectionBlock('Vehicle Strip')
    );
    anClicks(this.$el);
    scroller.add(this.$el, {
      tolerance: 365,
      after: () => {
        anComponentView(this.$el);
      }
    });
  }
};

export default vehicleStrip;
